// Modules
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

export function menuMain(props){
    if(!props.gameRunning){
        return(
            <div id="container-mainMenu">
                <div>
                    <Link to="/main/account">
                        <img src="./imgs/account.svg" className="mainMenuBtn" alt="Account"/>
                    </Link>
                </div>
                <div>
                    <Link to="/main">
                        <img src="./imgs/game.svg" className="mainMenuBtn" alt="Game"/>
                    </Link>
                </div>
                <div>
                    <Link to="/main/history">
                        <img src="./imgs/history.svg" className="mainMenuBtn" alt="History"/>
                    </Link>
                </div>
            </div>
        );
    }
    else{
        return(
            <div id="container-mainMenu">
                <div>
                    <Link to="/main/account">
                        <img src="./imgs/account.svg" className="mainMenuBtn" alt="Account"/>
                    </Link>
                </div>
                <div>
                    <Link to="/main/game">
                        <img src="./imgs/game.svg" className="mainMenuBtn" alt="Game"/>
                    </Link>
                </div>
                <div>
                    <Link to="/main/history">
                        <img src="./imgs/history.svg" className="mainMenuBtn" alt="History"/>
                    </Link>
                </div>
            </div>
        );
    }


}

const mapPropsToState = state =>({
    gameRunning: state.gameMngt.gameRunning
});

export default connect(mapPropsToState)(menuMain)


// WEBPACK FOOTER //
// ./src/comps/menu-main.js